module.exports = __webpack_public_path__ + "static/media/bg_1.b77b5d67.jpg";